module.exports = __webpack_public_path__ + "static/media/resubscribe-success.92a6eee8.svg";